var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCadFlag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 12.0002C24 7.24267 21.2313 3.13192 17.2174 1.19092V22.8094C21.2313 20.8685 24 16.7577 24 12.0002ZM0 12.0002C0 16.7577 2.76867 20.8685 6.78263 22.8095V1.19092C2.76867 3.13192 0 7.24267 0 12.0002ZM14.087 13.5654L16.1739 12.5219L15.1305 12.0002V10.9567L13.0435 12.0002L14.087 9.91323H13.0435L12 8.34803L10.9565 9.91323H9.91303L10.9565 12.0002L8.86955 10.9567V12.0002L7.82611 12.5219L9.91303 13.5654L9.39131 14.6089H11.4783V16.1741H12.5217V14.6089H14.6087L14.087 13.5654Z",
    fill: "#D80027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCadFlag);
export default __webpack_public_path__ + "static/media/CadFlag.6ffbd7569af647c606b25b2a5927718f.svg";
export { ForwardRef as ReactComponent };